import type { RouteObject } from 'react-router';
import { ModuleRoute } from '@/components/guards';

/** Rotas deste módulo, montadas dentro do layout do painel (caminhos relativos). */
export const inventoryRoutes: RouteObject[] = [
  {
    path: 'estoque',
    element: <ModuleRoute module="inventory" permission="inventory:read" />,
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./stock-list')).StockListPage }) },
      { path: 'movimentos', lazy: async () => ({ Component: (await import('./movements')).MovementsPage }) },
      {
        // Telas que mexem no saldo: só quem pode ajustar o estoque.
        element: <ModuleRoute permission="inventory:adjust" />,
        children: [
          { path: 'entrada', lazy: async () => ({ Component: (await import('./inbound')).StockEntryPage }) },
          { path: 'inventario', lazy: async () => ({ Component: (await import('./count')).InventoryCountPage }) },
          { path: 'importar', lazy: async () => ({ Component: (await import('./import')).StockImportPage }) },
        ],
      },
    ],
  },
];
